import { FC, useEffect } from "react";
import cx from "classnames";
import { Header } from "../../components/Header";
import ProgressBar from "../../components/ProgressBar";
import Submitted from "../Agreements/Submitted";
import Member from "../../models/Member";
import Agent from "../../models/Agent";
import { recordRumPageView } from "../../services/awsRum";
import hotJar from "../../services/hotJar";

type CompletedProps = {
  agentState: Agent
  member: Member
  setMember: React.Dispatch<React.SetStateAction<Member>>;
}

const Completed: FC<CompletedProps> = ({
  agentState,
  member,
  setMember
}: CompletedProps) => {

  useEffect(() => {

    recordRumPageView('Completed')
    hotJar.recordPageView('Completed')
  }, [agentState.id, agentState.parentAgentId, member.id])

  return (
    <div
      className={cx(
        "h-full w-full",
        "bg-gradient-to-r from-[#003764] to-[#53BFE7]"
      )}
    >
      <Header agentState={agentState} />
      <div className="border-b-2 border-b-orange"></div>

      <Submitted
        agentId={agentState.id}
        memberFirstName={member.firstName}
        memberLastName={member.lastName}
        memberId={member.id}
        setMember={setMember}
      />

      <div
        className={`fixed bottom-0 z-30 ml-auto mr-auto w-full bg-orange pt-1`}
      >
        <ProgressBar step={1} />
      </div>
    </div>
  );
};

export default Completed;
